import { Box, Typography, Button } from '@mui/material';
import FolderOffIcon from '@mui/icons-material/FolderOff';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import DescriptionIcon from '@mui/icons-material/Description';
import GroupIcon from '@mui/icons-material/Group';
import InboxIcon from '@mui/icons-material/Inbox';
import AddIcon from '@mui/icons-material/Add';

const VARIANTS = {
  projects: {
    icon: FolderOffIcon,
    title: 'No Projects Found',
    description: 'Get started by creating your first project',
    color: '#1976d2',
  },
  tasks: {
    icon: AssignmentLateIcon,
    title: 'No Tasks Yet',
    description: 'Add tasks to track your project progress',
    color: '#2e7d32',
  },
  search: {
    icon: SearchOffIcon,
    title: 'No Results Found',
    description: 'Try adjusting your search or filter criteria',
    color: '#ed6c02',
  },
  reports: {
    icon: DescriptionIcon,
    title: 'No Reports Available',
    description: 'Reports will appear here once created',
    color: '#9c27b0',
  },
  users: {
    icon: GroupIcon,
    title: 'No Users Found',
    description: 'Add team members to collaborate on projects',
    color: '#0288d1',
  },
  default: {
    icon: InboxIcon,
    title: 'Nothing Here Yet',
    description: 'This section is empty',
    color: '#757575',
  },
};

const EmptyState = ({
  variant = 'default',
  title,
  description,
  icon: CustomIcon,
  actionLabel,
  onAction,
  compact = false,
}) => {
  const config = VARIANTS[variant] || VARIANTS.default;
  const IconComponent = CustomIcon || config.icon;
  const displayTitle = title || config.title;
  const displayDescription = description || config.description;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: compact ? 4 : 8,
        px: 3,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: compact ? 64 : 80,
          height: compact ? 64 : 80,
          borderRadius: '50%',
          backgroundColor: `${config.color}10`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <IconComponent
          sx={{
            fontSize: compact ? 32 : 40,
            color: config.color,
            opacity: 0.8,
          }}
        />
      </Box>

      <Typography
        variant={compact ? 'subtitle1' : 'h6'}
        fontWeight={600}
        color="text.primary"
        sx={{ mb: 0.5 }}
      >
        {displayTitle}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 300, mb: actionLabel ? 3 : 0 }}
      >
        {displayDescription}
      </Typography>

      {actionLabel && onAction && (
        <Button
          variant="contained"
          size={compact ? 'small' : 'medium'}
          startIcon={<AddIcon />}
          onClick={onAction}
          sx={{ mt: 1 }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
